module.exports = __webpack_public_path__ + "static/assets/8771556be854985a93e479eecb02fad7.png";